import * as React from 'react';
import * as agui from 'arm-gui/dist/controls';


class TestASelect extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[TestASelect.jsx] ";
        this.invia = this.invia.bind(this);
        this.inviaReq = this.inviaReq.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.state = {
            risposta: "",
            rispostaReq: "chocolate",
            options: [
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' }
            ],
        }
    }

    inputChangeHandler(e, index) {
        // console.log(this.componentName + ' handleChange id: ' + id + ' value: ' + value);
        if (e !== null && e !== undefined) {
            let obj = {};
            let value = e.target.value;
            let id = e.target.id;
            obj[id] = value;
            this.setState(obj)
        }
    }
    invia() {

        //aggiungere la parte di validazione ... 

        let log = document.getElementById('log');
        log.insertAdjacentHTML('beforeend', '<h1> risposta </h1> ' + this.state.risposta);
    }
    inviaReq() {

        //aggiungere la parte di validazione ... 

        let log = document.getElementById('log');
        log.insertAdjacentHTML('beforeend', '<h1> risposta required</h1> ' + this.state.rispostaReq);
    }
    render() {
        console.log(this.componentName + 'render');
        return (
            <div>
                <h1>Test aSelect </h1>
                <agui.aSelectV2
                    id="risposta"
                    // required={true}
                    value={this.state.risposta}
                    label="Combo box 02"
                    items={this.state.options}
                    onChange={this.inputChangeHandler}
                    valueKey="value"
                    labelKey="label"

                />
                <hr />
                <button className="btn btn-info" onClick={this.invia}> Invia </button>
                <h1>Test aSelect Required </h1>
                <agui.aSelectV2
                    id="rispostaReq"
                    required={true}
                    addEmptyOption={false}
                    value={this.state.rispostaReq}
                    label="Combo box 02"
                    items={this.state.options}
                    onChange={this.inputChangeHandler}
                    valueKey="value"
                    labelKey="label"

                />
                <hr />
                <button className="btn btn-info" onClick={this.inviaReq}> Invia </button>
                <div id="log"></div>
            </div>
        );
    }
}


export default TestASelect;